import axios from "axios";
import environment from "constants/apiConst";

/**
 * Realiza polling al endpoint getJobStatusControl hasta que el job finalice o falle.
 * @param {string} token - Bearer token de autenticación.
 * @param {number|string} jobStatusControlId - ID del registro en job_status_controls.
 * @param {number} interval - Intervalo en milisegundos entre cada consulta (default 3000).
 * @returns {Promise<string>} Resuelve con 'finished' si el job terminó exitosamente.
 * @throws {string} Rechaza con el mensaje de error si el job falló.
 */
export const pollJobStatusControl = (token, jobStatusControlId, interval = 3000) => {
  return new Promise((resolve, reject) => {
    const intervalId = setInterval(async () => {
      try {
        const res = await axios.get(
          `${environment.GET_JOB_STATUS_CONTROL}/${jobStatusControlId}`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : "",
            },
          }
        );
        if (res.data.status.code === 200) {
          if (res.data.status.data.finished) {
            clearInterval(intervalId);
            resolve("finished");
          }
        } else {
          clearInterval(intervalId);
          reject(res.data.status.message || "El proceso ha fallado.");
        }
      } catch (err) {
        clearInterval(intervalId);
        reject(
          err?.response?.data?.status?.message ||
            err.message ||
            "Error consultando el estado del proceso."
        );
      }
    }, interval);
  });
};
